import jwtDecode from "jwt-decode";

import { UserManager, WebStorageStateStore } from "oidc-client-ts";

var currentUser = null;

/* eslint-disable camelcase */
// Disable camelcase lint here because these props are what the library needs
const manager = new UserManager({
  userStore: new WebStorageStateStore(),
  authority: process.env.VUE_APP_OIDC_SETTINGS_AUTH,
  client_id: process.env.VUE_APP_OIDC_SETTINGS_CLIENT,
  redirect_uri: window.location.origin + "/",
  silent_redirect_uri: window.location.origin + "/",
  response_mode: "fragment",
  response_type: "code",
  scope: process.env.VUE_APP_OIDC_SETTINGS_SCOPE,
  automaticSilentRenew: true,
  loadUserInfo: false,
});
manager.events.addUserLoaded((user) => {
  currentUser = user;
  /**
   * In order to receive App Roles in the access_token you must request the
   * <client_id>/.default scope during login. However, when you request this
   * scope AzureAD returns several scopes back. The .default scope can't be
   * combined with other scopes on request and oidc-client-ts includes all
   * received scopes in the refresh request which thus causes it to fail.
   * This bit of code overwrites the received scopes with just .default
   * when the user object is saved. I opened an issue for this here:
   * https://github.com/authts/oidc-client-ts/issues/695
   */
  currentUser.scope = process.env.VUE_APP_OIDC_SETTINGS_SCOPE;
  manager.storeUser(currentUser);
});

export default {
  userManager: manager,
  isLoginRedirect(url = window.location.href) {
    return (
      url.includes("/#") && url.includes("state=") && url.includes("code=")
    );
  },
  isUserLoggedIn() {
    return new Promise((resolve, reject) => {
      this.userManager
        .getUser()
        .then((user) => {
          if (user === null || user.expired) {
            currentUser = null;
            resolve(false);
          } else {
            currentUser = user;
            resolve(true);
          }
        })
        .catch((error) => reject(error));
    });
  },
  getDecodedAccessToken() {
    var access = this.getAccessToken();

    if (access != null) {
      return jwtDecode(access);
    }
    const emptyObject = {};
    return emptyObject;
  },
  getAccessToken() {
    if (currentUser != null) {
      return currentUser.access_token;
    }

    return null;
  },
  login() {
    return this.userManager.signinRedirect();
  },
  loginCallback() {
    return this.userManager.signinRedirectCallback().then((user) => {
      currentUser = user;
    });
  },
  silentRefreshCallback() {
    return this.userManager.signinSilentCallback();
  },
};
